// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Layout } from '~/components';

import { ILAB } from '../pages';
import ExercisesRoutes from './exercises.routes';
import MethodRoutes from './methods.routes';
import SymbologyRoutes from './symbology.routes';
import TrainingStoreRoutes from './trainingStore.routes';

function ILABRoutes(): ReactElement {
  return (
    <Layout title="I.LAB">
      <Route path="/ilab" exact component={ILAB} />
      <Route path="/ilab/methods" component={MethodRoutes} />
      <Route path="/ilab/exercises" component={ExercisesRoutes} />
      <Route path="/ilab/symbology" component={SymbologyRoutes} />
      <Route path="/ilab/training-store" component={TrainingStoreRoutes} />
    </Layout>
  );
}

export default ILABRoutes;
